var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'BookingPresetList'
      },
      "active": ""
    }
  }, [_vm._v(" 個人預約班表 ")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-8 mb-2 font-weight-bold"
  }, [_vm._v("個人預約班表" + _vm._s(_vm.targetStaff ? " - ".concat(_vm.targetStaff.name) : ''))])]), _c('div', {
    staticClass: "d-flex flex-wrap mb-4 mb-xl-2 justify-content-between align-items-center"
  }, [_c('div', [_c('b-form-select', {
    attrs: {
      "options": _vm.bookingPresetsOptions
    },
    on: {
      "change": _vm.handlePresetChange
    },
    model: {
      value: _vm.query.preset_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "preset_id", $$v);
      },
      expression: "query.preset_id"
    }
  })], 1), _c('div', {
    staticClass: "d-flex flex-column flex-md-row align-items-center"
  }, [_vm.checkPermission([_vm.consts.MY_BOOKING_SHIFT]) || _vm.checkPermission([_vm.consts.BRANCH_DETAIL_BOOKING_SHIFT]) ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "flex-shrink-0 m-2",
    attrs: {
      "title": !_vm.isStaffShiftSelectionEnabled ? '此預約需啟用員工班表，才能設定排班' : ''
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "to": {
        name: 'BookingShiftCreate',
        query: {
          preset_id: _vm.query.preset_id,
          staff_id: _vm.staffId
        }
      },
      "disabled": !_vm.isStaffShiftSelectionEnabled || _vm.pageDisabled
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增 ")])], 1) : _vm._e(), _c('b-form-select', {
    staticClass: "m-2",
    attrs: {
      "options": _vm.shiftTypeOptions
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.shift_type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "shift_type", $$v);
      },
      expression: "query.shift_type"
    }
  }), _c('div', {
    staticClass: "d-flex align-items-stretch"
  }, [_c('DateSearchPicker', {
    attrs: {
      "startedPlaceholder": "開始時間",
      "endedPlaceholder": "結束時間"
    },
    on: {
      "input": _vm.handleDateChange
    },
    model: {
      value: _vm.query,
      callback: function callback($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }), _c('b-button', {
    staticStyle: {
      "height": "auto"
    },
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.bookingShifts,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.MY_BOOKING_SHIFT]) || _vm.checkPermission([_vm.consts.BRANCH_DETAIL_BOOKING_SHIFT]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'BookingShiftView',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.MY_BOOKING_SHIFT]) || _vm.checkPermission([_vm.consts.BRANCH_DETAIL_BOOKING_SHIFT]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'BookingShiftEdit',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.MY_BOOKING_SHIFT]) || _vm.checkPermission([_vm.consts.BRANCH_DETAIL_BOOKING_SHIFT]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteBookingShift(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1), _c('FormUrlModal', {
    ref: "formUrlModal"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }